import { lockScroll } from '../modules/lockScroll.js';
import Mustache from 'mustache';

var takeoverVideo = {
	$button: $(".play-button"),
	$closeButton: $(".js-video-takeover .js-close-button"),
	$videoElem: $(".video-takeover-content")
};

takeoverVideo.init = () => {

	takeoverVideo.$button.on("click", e => {

		let getCookie = function (name) {
			var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
			if (match) return match[2];
		}

		let video_on = false; //block video's by default

		//if cookie_settings is set and not = default
		if (typeof getCookie('cookie_settings') != 'undefined' && getCookie('cookie_settings') != 'default') {
			video_on = true;  //allow video's to play
		}

		e.preventDefault();
		takeoverVideo.$elem = takeoverVideo.$button.closest('.block-video').find('.js-video-takeover');

		var iframe = document.createElement("iframe");
		if (video_on ){
			iframe.setAttribute("src", e.currentTarget.getAttribute('href'));
		}
		else{
			iframe.setAttribute("src", e.currentTarget.getAttribute('data-blocked'));
		}

		takeoverVideo.$videoElem.html(iframe);
		takeoverVideo.open();
	 });

	takeoverVideo.$closeButton.on("click", e => {
		e.preventDefault();
		takeoverVideo.close();
	});
};

takeoverVideo.open = () => {
	takeoverVideo.$elem.addClass("show");
	$('html, body').on("keyup", e => {
		e.preventDefault();
		if (e.keyCode === 27) {
			takeoverVideo.close();
		}
	});

	lockScroll.init(true);

};

takeoverVideo.close = () => {
	lockScroll.init(false);
	takeoverVideo.$elem.removeClass("show");
	setTimeout(() => {
		takeoverVideo.$videoElem.html("");
	}, 500);
	$('html, body').off("keyup");
};

export { takeoverVideo };
